import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { SidenavItem } from 'src/app/shared/interfaces/sidenav-item.interface';
import { GlobalService } from 'src/app/shared/services/global.service';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CompanyApiService } from 'src/app/company/services/company-api.service';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidenavComponent extends BaseComponent implements OnInit {

  @Input()
  @HostBinding('class.collapsed')
  public collapsed: boolean;

  @Input()
  @HostBinding('class.expanded')
  public expanded: boolean;

  @Output() public messageEvent = new EventEmitter<boolean>();

  public isRkon: boolean = false;
  public logoUrl: SafeUrl | null = null;
  public isDynamicLogoEnabled: boolean = false;
  public sidenavUserVisible$ = this._themeService.config$.pipe(map(config => config.sidenavUserVisible));
  public items$: Observable<SidenavItem[]>;

  constructor(
    private _router: Router,
    private _sidenavService: SidenavService,
    private _globalService: GlobalService,
    private _companyService: CompanyApiService,
    private _themeService: ThemeService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog
  ) {
    super();
  }

  ngOnInit() {
    this.isRkon = this._globalService.isRkon;
    this.isDynamicLogoEnabled = this._globalService.company.dynamicLogo;
    if (this._globalService.company.hasLogo) {
      this.fetchLogo();
    }
    this.items$ = this._sidenavService.items$.pipe(
      map((items: SidenavItem[]) => this._sidenavService.sortRecursive(items, 'position'))
    );
  }

  receiveMessage($event: boolean) {
    // alert('ok')
    this.messageEvent.emit(true)
  }

  toggleCollapsed() {
    this._sidenavService.toggleCollapsed();
  }

  fetchLogo() {
    const companyId = this._globalService.company.id;

    this._companyService.getCompanyLogo(companyId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: Blob) => {
          const objectURL = URL.createObjectURL(res);
          this.logoUrl = this._sanitizer.bypassSecurityTrustUrl(objectURL);
        },
        (err) => {
          console.error('Error fetching logo:', err);
        }
      );
  }

  @HostListener('mouseenter')
  @HostListener('touchenter')
  onMouseEnter() {
    this._sidenavService.setExpanded(true);
  }

  @HostListener('mouseleave')
  @HostListener('touchleave')
  onMouseLeave() {
    this._sidenavService.setExpanded(false);
  }
}
